export const SYMBOL_EXISTING = Symbol('existing');
export const SYMBOL_DIRTY = Symbol('dirty');
export const SYMBOL_INITIAL = Symbol('initial');



// WEBPACK FOOTER //
// ./src/views/common/symbols.js